import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { InputSwitch } from "primereact/inputswitch";
import useAuthStore from "@/shared/zustand/authStore";
import useToastStore from "@/shared/zustand/toastStore";
import { Skeleton } from "primereact/skeleton";
import axios from "axios";
import { Button } from "primereact/button";
import { RefreshCcw } from "lucide-react";
import { DATA_SOURCES } from "@/constants/LandingSection";
import { loginWithGoogle } from "@/core/api/api";
const DataSourcesTab = () => {
    const { user, setUser } = useAuthStore();
    const showToast = useToastStore((state) => state.showToast);
    const [loading, setLoading] = useState(true);
    const [dataSources, setDataSources] = useState([]);
    useEffect(() => {
        if (!user?.provider?.scope)
            return;
        const userScopes = user.provider.scope.split(" ");
        const sources = DATA_SOURCES.map((source) => ({
            ...source,
            scopes: source.scopes.map((scope) => ({
                ...scope,
                isEnabled: userScopes.includes(scope.scope),
            })),
        }));
        setDataSources(sources);
        setLoading(false);
    }, [user]);
    const handleToggle = (categoryIndex, scopeIndex) => {
        const updatedSources = [...dataSources];
        updatedSources[categoryIndex].scopes[scopeIndex].isEnabled =
            !updatedSources[categoryIndex].scopes[scopeIndex].isEnabled;
        setDataSources(updatedSources);
    };
    const handleLoginWithGoogle = async (newScopes) => {
        try {
            // const response = await axios.post(
            //   process.env.VITE_APPSEC_AUTH_BACKEND_URL + "/api/auth/google/addScopes",
            //   {
            //     scopes: newScopes,
            //   },
            //   {
            //     headers: {
            //       "Content-Type": "application/json",
            //     },
            //   }
            // );
            const { responseData, error } = await loginWithGoogle(newScopes);
            console.log("Response Data: ", responseData);
            console.log("addScopes response:", responseData?.authorizationUrl);
            if (responseData?.authorizationUrl) {
                // console.log("addScopes response:", response);
                window.location.href = responseData.authorizationUrl;
            }
            else {
                console.error("Authorization URL not found in response");
                showToast("error", "Error", "Authorization URL not found in response");
            }
        }
        catch (error) {
            console.error("Error during Google login:", error);
            showToast("error", "Error", "An error occurred during Google login, check console for more details.");
        }
    };
    const revokeToken = async () => {
        try {
            // Get the current user data that contains token information
            const { user } = useAuthStore.getState();
            if (!user?.provider?.access_token) {
                console.error("No access token found to revoke");
                return false;
            }
            // Call Google's token revocation endpoint
            const response = await axios.post(`https://accounts.google.com/o/oauth2/revoke?token=${user.provider?.access_token}`, {}, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            if (response.status === 200) {
                console.log("Token revoked successfully");
                return true;
            }
            else {
                console.error("Failed to revoke token:", response.statusText);
                return false;
            }
        }
        catch (error) {
            console.error("Error revoking token:", error);
            return false;
        }
    };
    const updateScopes = async () => {
        await revokeToken();
        let newScopes = dataSources
            .flatMap((source) => source.scopes.filter((scope) => scope.isEnabled).map((s) => s.scope))
            .join(" ");
        newScopes = `email profile openid ${newScopes}`;
        console.log("Updated Scopes", newScopes);
        try {
            // await axios.post("/api/update-scopes", { scopes: newScopes });
            await handleLoginWithGoogle(newScopes);
            if (user && user._id) {
                setUser({
                    ...user,
                    _id: user._id, // Ensure _id is explicitly set
                    provider: {
                        ...user.provider,
                        scope: newScopes,
                    },
                });
            }
            else {
                console.error("User is null or missing _id");
            }
            showToast("success", "Success", "Scopes updated successfully!");
        }
        catch (error) {
            showToast("error", "Error", "Failed to update scopes.");
            console.error("Error updating scopes:", error);
        }
    };
    return (_jsxs("div", { className: "w-full h-full flex flex-col gap-y-6", children: [_jsxs("div", { className: "flex justify-between items-start", children: [_jsxs("div", { children: [_jsx("h3", { className: "text-lg text-[#101828] font-medium", children: "Connected Data Sources" }), _jsx("p", { className: "text-base text-[#667085]", children: "Enable or disable data sources to control access." })] }), _jsxs(Button
                    // disabled
                    , { 
                        // disabled
                        onClick: updateScopes, className: "flex-shrink-0 px-4 py-2 text-sm flex items-center justify-center gap-2 rounded-[6px] border border-[#d1d5db] text-[#5928ed]", children: [_jsx(RefreshCcw, { size: 16 }), _jsx("span", { children: "Update Scopes" })] })] }), _jsx("div", { className: "w-full", children: loading ? ([1, 2, 3].map((key) => (_jsxs("div", { className: "w-full flex items-center gap-x-8 border-b border-[#EAECF0] py-6", children: [_jsx(Skeleton, { width: "6rem", height: "42px" }), _jsx(Skeleton, { width: "100%", height: "42px", className: "flex-1 max-w-[640px]" })] }, key)))) : dataSources.length > 0 ? (dataSources.map((source, categoryIndex) => (_jsxs("div", { className: "flex mb-4 pb-4  border-b border-[#EAECF0]", children: [_jsxs("div", { className: "h-fit pt-3 flex items-center gap-x-5", children: [source.icon ? _jsx(source.icon, {}) : "", _jsxs("h4", { className: "w-[300px] text-base font-medium text-[#344054]", children: [source.category, _jsx("br", {}), _jsx("span", { className: "text-sm", children: source.subtitle })] })] }), _jsx("div", { children: source.scopes.map((scope, scopeIndex) => (_jsxs("div", { className: "w-full flex items-center gap-x-4 py-3", children: [_jsx("div", { className: "w-24", children: _jsx(InputSwitch, { readOnly: true, 
                                            // disabled
                                            checked: scope.isEnabled, onChange: () => handleToggle(categoryIndex, scopeIndex), className: "scale-75 md:scale-100 text-[#5928ed]" }) }), _jsx("div", { className: "flex-1 max-w-[640px] flex items-center gap-x-3", children: _jsx("span", { className: "text-sm text-[#344054]", children: scope.label }) })] }, scopeIndex))) })] }, categoryIndex)))) : (_jsx("p", { className: "text-gray-500 text-sm", children: "No connected data sources." })) })] }));
};
export default DataSourcesTab;
